import $ from 'jquery';
import domReady from '@wordpress/dom-ready';
import * as Focus from '../../../assets/scripts/common/focus';

const OPEN_CLASS = 'team-members__modal--open';

domReady(() => {
  const modal = document.querySelector('.team-members__modal');

  if (!modal) {
    return;
  }

  const triggers = document.querySelectorAll('.team-members__card-trigger');
  const closeEls = modal.querySelectorAll('[data-team-modal-close]');
  const closeBtn = modal.querySelector('.team-members__modal-close');
  const slots = {
    name: modal.querySelector('[data-team-modal-slot="name"]'),
    position: modal.querySelector('[data-team-modal-slot="position"]'),
    photo: modal.querySelector('[data-team-modal-slot="photo"]'),
    bio: modal.querySelector('[data-team-modal-slot="bio"]'),
    links: modal.querySelector('[data-team-modal-slot="links"]'),
  };

  let lastTrigger = null;

  function handleKeydown(event) {
    if ('Escape' === event.key) {
      closeModal();
    }
  }

  function fillSlot(key, template) {
    const source = template.content.querySelector(`[data-field="${key}"]`);
    slots[key].innerHTML = source ? source.innerHTML : '';
  }

  function openModal(trigger) {
    const template = document.getElementById(trigger.dataset.teamModalSource);

    if (!template) {
      return;
    }

    Object.keys(slots).forEach((key) => fillSlot(key, template));

    lastTrigger = trigger;

    modal.classList.add(OPEN_CLASS);
    document.documentElement.classList.add('lockedPosition');
    Focus.trapFocusInside($(modal));
    window.addEventListener('keydown', handleKeydown);

    if (closeBtn) {
      closeBtn.focus();
    }
  }

  function closeModal() {
    if (!modal.classList.contains(OPEN_CLASS)) {
      return;
    }

    modal.classList.remove(OPEN_CLASS);
    document.documentElement.classList.remove('lockedPosition');
    Focus.untrapFocusInside($(modal));
    window.removeEventListener('keydown', handleKeydown);

    if (lastTrigger) {
      lastTrigger.focus();
      lastTrigger = null;
    }
  }

  triggers.forEach((trigger) => {
    trigger.addEventListener('click', () => openModal(trigger));
  });

  closeEls.forEach((el) => {
    el.addEventListener('click', closeModal);
  });
});
